import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import AppShell from "../components/AppShell";
import AdminManualPayments from "./AdminManualPayments";
import AdminStripe from "./AdminStripe";
import EmailFailuresBanner from "./EmailFailuresBanner";

const TABS = [
  { id: "cuba", label: "🇨🇺 Cuba", testid: "admin-tab-cuba" },
  { id: "stripe", label: "💳 Stripe", testid: "admin-tab-stripe" },
];

export default function AdminPanel() {
  const { user } = useAuth();
  const [active, setActive] = useState("cuba");

  // Server-side guard is the source of truth; this is UX-only
  if (!user?.is_admin) return <Navigate to="/panel" replace />;

  const subtitle = active === "cuba"
    ? "Activación manual de acceso premium sin Stripe."
    : "Consulta de solo lectura de las transacciones procesadas por Stripe.";

  return (
    <AppShell title="Panel administrativo" subtitle={subtitle}>
      <div className="max-w-5xl">
        <EmailFailuresBanner />
        <div
          role="tablist"
          className="inline-flex rounded-full p-1 border border-[var(--mep-border)] bg-[var(--mep-surface)] mb-8"
        >
          {TABS.map((t) => {
            const isActive = active === t.id;
            return (
              <button
                key={t.id}
                role="tab"
                aria-selected={isActive}
                data-testid={t.testid}
                onClick={() => setActive(t.id)}
                className={`px-5 py-2.5 text-sm rounded-full transition ${
                  isActive
                    ? "bg-[var(--mep-pink)] text-white shadow-[0_0_18px_rgba(232,61,132,0.35)]"
                    : "text-[var(--mep-text-muted)] hover:text-white"
                }`}
              >
                {t.label}
              </button>
            );
          })}
        </div>

        <div>
          {active === "cuba" ? (
            <AdminManualPayments embedded />
          ) : (
            <AdminStripe embedded />
          )}
        </div>
      </div>
    </AppShell>
  );
}
